import { constants } from "../constant/constants";
import {
  CxAppSettings,
  normalizeCxAppSettings,
} from "../model/cx-app-settings";
import { HttpHelper } from "./http-helper-service";
import store from "../../root/store/store";

export class LocalStorageService {
  static setItem(key: string, data: any): void {
    localStorage.setItem(key, data);
    if (key === constants.localStorage.keys.cxappsettings) {
      store.commit("MasterModule/SET_RESET_THEME");
    }
  }

  static getItem(key: string) {
    return localStorage.getItem(key);
  }

  static removeItem(key: string): void {
    localStorage.removeItem(key);
    if (key === constants.localStorage.keys.cxappsettings) {
      store.commit("MasterModule/SET_RESET_THEME");
    }
  }

  public static getCxAppSettingsJson(): string {
    const raw = localStorage.getItem(constants.localStorage.keys.cxappsettings);
    if (raw) {
      return raw + "";
    }
    return "";
  }

  public static getCxAppSettingsFromLocalStorage(): CxAppSettings | undefined {
    const cxAppSettingsJson = this.getCxAppSettingsJson();
    if (!cxAppSettingsJson) {
      return undefined;
    }
    try {
      return normalizeCxAppSettings(JSON.parse(cxAppSettingsJson)) ?? undefined;
    } catch {
      return undefined;
    }
  }

  public static async getContactAppSettings(): Promise<
    CxAppSettings | undefined
  > {
    let cxAppSettings: CxAppSettings | undefined =
      this.getCxAppSettingsFromLocalStorage();
    if (!cxAppSettings) {
      cxAppSettings = (await HttpHelper.getData(
        constants.apiUrl.serviceProviderUrls.getCXAppConfiguration,
      )) as CxAppSettings;
      if (cxAppSettings) {
        this.setItem(
          constants.localStorage.keys.cxappsettings,
          JSON.stringify(cxAppSettings),
        );
      }
    }
    return cxAppSettings;
  }
}
